import { render } from "./ruleModal.vue?vue&type=template&id=5e442e7e&scoped=true"
import script from "./ruleModal.vue?vue&type=script&lang=js"
export * from "./ruleModal.vue?vue&type=script&lang=js"

import "./ruleModal.vue?vue&type=style&index=0&id=5e442e7e&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/ydsk-ph-h5-bankv3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e442e7e"]])

export default __exports__